import { UsuarioService } from '@account/usuario.service';
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CierreTurnoService } from '@cierreTurno/cierre-turno.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BotonGrupo } from '@shared/models/cierreTurno/BotonesGrupo';
import { Contacto } from '@shared/models/cierreTurno/Contacto';
import { SharedService } from '@shared/shared.service';
import { CustomValidatorsService } from '@shared/validators/custom-validators.service';
import { MessageService } from '@shell/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contactos-detalle',
  templateUrl: './contactos-detalle.component.html',
  styleUrl: './contactos-detalle.component.scss'
})
export class ContactosDetalleComponent implements OnInit, OnChanges {

  contactoForm: FormGroup;

  @Input() contactoSeleccionado: Contacto;  
  @Output() recargarListaDeContactos = new EventEmitter<boolean>();

  editandoContacto: boolean = false;
  grabando: boolean = false;
  seleccionados: number[] = [];
  change$: Subscription;
  codigoAeroplanta: string;
  nombreAeroplanta: string;
  borrando: boolean = false;
  botonesGrupo: BotonGrupo[];

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder, 
    private spinner: NgxSpinnerService,
    private cierreTurnoService: CierreTurnoService, 
    private messageService: MessageService,
    private usuarioService: UsuarioService,
    sharedService: SharedService) { 
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(() => {
        this.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
        this.cambiarAeroplanta();
      });
    }


  ngOnInit() {    
    this.botonesGrupo = this.cierreTurnoService.botonesGrupo;
    this.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
    this.crearFormulario();
    if (this.contactoSeleccionado) {
      this.cargarFormulario();
    }
  }

  cambiarAeroplanta() {
    this.cargarFormulario();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.contactoSeleccionado?.firstChange) {
      this.contactoSeleccionado = changes.contactoSeleccionado?.currentValue;
      this.cargarFormulario();
    }    
  }

  handleSpinner(value: boolean) {
    value ? this.spinner.show('spinnerDetalle') : this.spinner.hide('spinnerDetalle');
    this.grabando = value;
  }
  
  crearFormulario() {
    this.contactoForm = this.formBuilder.group({
      nombreFormControl: ['', Validators.required],     
      numeroFormControl: ['', Validators.required],
      emailFormControl: ['', [Validators.required, CustomValidatorsService.emailValidator]],
      gruposAeroplanta: ['']
    });
  }

  cargarFormulario() {
    this.nombreAeroplanta = this.usuarioService.getAeroplantaActual().nombre;
    this.editandoContacto = true;
    this.nombreFormControl.setValue(this.contactoSeleccionado.nombre);
    this.numeroFormControl.setValue(this.contactoSeleccionado.numero);
    this.emailFormControl.setValue(this.contactoSeleccionado.email);
    this.botonesGrupo.forEach(boton => {
      const grupos = this.contactoSeleccionado.gruposAeroplanta?.find(g => g.codigoAeroplanta === this.codigoAeroplanta);
      boton.seleccionado = grupos?.gruposContacto?.includes(boton.valor);
    });
  }

  seleccionarGrupo(boton: BotonGrupo) {
    boton.seleccionado = !boton.seleccionado;
    this.seleccionados = this.botonesGrupo
      .filter(b => b.seleccionado)
      .map(b => b.valor);
  }

  async agregarContacto() {
    const haySeleccionado = this.botonesGrupo.some(boton => boton.seleccionado);
    if (!haySeleccionado) {
      this.messageService.showErrorMessage('Debe seleccionar al menos un grupo.');
      return;
    }

    const contacto = new Contacto();
    contacto.nombre = this.nombreFormControl.value;
    contacto.numero = this.numeroFormControl.value;
    contacto.email = this.emailFormControl.value;

    console.log('gr: ', this.contactoSeleccionado?.gruposAeroplanta);

    if (this.editandoContacto) {
      const posGrupoAeroplanta = this.contactoSeleccionado?.gruposAeroplanta?.findIndex(a => a.codigoAeroplanta === this.codigoAeroplanta);
      if (posGrupoAeroplanta !== -1) {
        this.contactoSeleccionado.gruposAeroplanta[posGrupoAeroplanta].gruposContacto = this.botonesGrupo
          .filter(boton => boton.seleccionado)
          .map(boton => boton.valor);
        contacto.gruposAeroplanta = this.contactoSeleccionado.gruposAeroplanta;
      } else {
        const grupos = this.contactoSeleccionado.gruposAeroplanta;
        grupos.push({ codigoAeroplanta: this.codigoAeroplanta, gruposContacto: this.botonesGrupo.filter(b => b.seleccionado).map(b => b.valor) })
        contacto.gruposAeroplanta = grupos;
      }
    } else {
      contacto.gruposAeroplanta = [
        ...(contacto.gruposAeroplanta || []),
        { codigoAeroplanta: this.codigoAeroplanta, gruposContacto: this.botonesGrupo.filter(b => b.seleccionado).map(b => b.valor) }
      ];  
    }

    try {
      this.handleSpinner(true);
      if (this.editandoContacto) { contacto.id = this.contactoSeleccionado.id }
      const r = this.editandoContacto 
        ? await this.cierreTurnoService.putContactos(contacto) 
        : await this.cierreTurnoService.postContactos(contacto);
        if (r) {
          this.messageService.showSuccessMessage(`El contacto fue ${this.editandoContacto ? 'editado' : 'creado'} con éxito`);
          this.handleSpinner(false);
          this.recargarListaDeContactos.emit(true);
          this.activeModal.close();
        }
    } catch (error) {
      this.messageService.showErrorMessage(error.message + " " + error.description);
      this.handleSpinner(false);
    }
  }

  async borrarContacto() {
    try {
      this.borrando = true;
      const r = await this.cierreTurnoService.deleteContactos(this.contactoSeleccionado.id);
      if (r) {
        this.messageService.showSuccessMessage('El contacto fue borrado con éxito.');
        this.borrando = false;
        this.recargarListaDeContactos.emit(true);
      }
    } catch (error) {
      this.messageService.showErrorMessage(error.message + " " + error.description);
      this.borrando = false;
    }
  }

  get title(): string {
    return this.contactoSeleccionado ? 'Editar Contacto: ' + this.contactoSeleccionado?.nombre : 'Nuevo Contacto';
  }

  get nombreFormControl() {
    return this.contactoForm.get('nombreFormControl');
  }

  get numeroFormControl() {
    return this.contactoForm.get('numeroFormControl');
  }

  get emailFormControl() {
    return this.contactoForm.get('emailFormControl')
  }

}
